module.exports = __webpack_public_path__ + "img/PlaceHolderSquare.42d4a5be.png";